import { RECEIVE_CUSTOMER_SOFT_AUTH } from 'constants/reduxActions';

interface CustomerReducerPayload {
  isRecognizedCustomer: boolean;
  type: string;
}

export default function customerReducer(state = null, payload: CustomerReducerPayload) {
  if (payload.type === RECEIVE_CUSTOMER_SOFT_AUTH) {
    return payload.isRecognizedCustomer;
  }

  return state;
}
